import { render, staticRenderFns } from "./addOrEditDialog.vue?vue&type=template&id=241c4ebe&scoped=true&"
import script from "./addOrEditDialog.vue?vue&type=script&lang=js&"
export * from "./addOrEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditDialog.vue?vue&type=style&index=0&id=241c4ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c4ebe",
  null
  
)

export default component.exports